import type { WidgetType } from '../../../types/bi';

const COORDINATE_WIDGETS: WidgetType[] = ['bar', 'line', 'area', 'scatter', 'heatmap', 'waterfall'];
const PROJECTION_WIDGETS: WidgetType[] = ['line', 'area'];
const LEGEND_WIDGETS: WidgetType[] = [
  'bar',
  'line',
  'area',
  'pie',
  'donut',
  'scatter',
  'heatmap',
  'funnel',
  'treemap',
  'waterfall',
];
const TOOLTIP_WIDGETS: WidgetType[] = [
  'bar',
  'line',
  'area',
  'pie',
  'donut',
  'scatter',
  'heatmap',
  'funnel',
  'gauge',
  'treemap',
  'waterfall',
];
const DATA_LABEL_WIDGETS: WidgetType[] = [
  'bar',
  'line',
  'area',
  'pie',
  'donut',
  'funnel',
  'treemap',
  'waterfall',
];
const DATA_ZOOM_WIDGETS: WidgetType[] = ['bar', 'line', 'area'];
const TEMPORAL_AXIS_WIDGETS: WidgetType[] = ['line', 'area'];
const DIMENSION_OPTIONAL_WIDGETS: WidgetType[] = ['kpi', 'gauge'];
const MEASURE_OPTIONAL_WIDGETS: WidgetType[] = ['data_table'];

export interface WidgetCapabilities {
  supportsProjection: boolean;
  supportsAnnotations: boolean;
  supportsLegend: boolean;
  supportsTooltip: boolean;
  supportsDataLabels: boolean;
  supportsGridLines: boolean;
  supportsDataZoom: boolean;
  supportsAxisLabels: boolean;
  supportsTemporalAxis: boolean;
  requiresDimension: boolean;
  requiresMeasure: boolean;
}

function includesWidget(list: WidgetType[], widgetType?: WidgetType): boolean {
  return !!widgetType && list.includes(widgetType);
}

export function getWidgetCapabilities(widgetType?: WidgetType): WidgetCapabilities {
  if (!widgetType) {
    return {
      supportsProjection: true,
      supportsAnnotations: true,
      supportsLegend: true,
      supportsTooltip: true,
      supportsDataLabels: true,
      supportsGridLines: true,
      supportsDataZoom: true,
      supportsAxisLabels: true,
      supportsTemporalAxis: true,
      requiresDimension: true,
      requiresMeasure: true,
    };
  }

  const isCoordinateWidget = includesWidget(COORDINATE_WIDGETS, widgetType);

  return {
    supportsProjection: includesWidget(PROJECTION_WIDGETS, widgetType),
    supportsAnnotations: isCoordinateWidget,
    supportsLegend: includesWidget(LEGEND_WIDGETS, widgetType),
    supportsTooltip: includesWidget(TOOLTIP_WIDGETS, widgetType),
    supportsDataLabels: includesWidget(DATA_LABEL_WIDGETS, widgetType),
    supportsGridLines: isCoordinateWidget,
    supportsDataZoom: includesWidget(DATA_ZOOM_WIDGETS, widgetType),
    supportsAxisLabels: isCoordinateWidget,
    supportsTemporalAxis: includesWidget(TEMPORAL_AXIS_WIDGETS, widgetType),
    requiresDimension: !includesWidget(DIMENSION_OPTIONAL_WIDGETS, widgetType),
    requiresMeasure: !includesWidget(MEASURE_OPTIONAL_WIDGETS, widgetType),
  };
}
